import { Link } from "react-router-dom";
import { Home, Wrench, Phone, Compass } from "lucide-react";
import SubLayout from "@/components/site/SubLayout";
import Seo from "@/seo/Seo";
import { SITE } from "@/data/site";

export default function NotFound() {
  // Client-side 404: signal non-index + prerender status for crawlers/prerender services.
  return (
    <SubLayout>
      <Seo
        title="Page Not Found (404) | The VIN Verifier CA"
        description="Sorry, the page you were looking for could not be found. Return home or contact The VIN Verifier CA for mobile VIN verification in Orange County & LA."
        path="/404"
        noindex
      />
      <div className="max-w-2xl mx-auto px-5 lg:px-8 py-24 lg:py-32 text-center">
        <div className="font-display font-extrabold text-brand text-7xl sm:text-8xl">404</div>
        <h1 className="font-display font-bold text-ink text-2xl sm:text-3xl mt-4">Page Not Found</h1>
        <p className="text-slate2 text-base mt-4 leading-relaxed">
          Sorry — the page you were looking for doesn't exist or may have moved. Let's get you back on track.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link to="/" className="btn-accent rounded-full px-6 py-3.5 text-sm font-semibold flex items-center gap-2 w-full sm:w-auto justify-center"><Home size={17} /> Back to Home</Link>
          <Link to="/services/mobile-vin-verification" className="btn-outline rounded-full px-6 py-3.5 text-sm font-semibold flex items-center gap-2 w-full sm:w-auto justify-center"><Wrench size={17} /> Our Services</Link>
          <Link to="/contact" className="btn-outline rounded-full px-6 py-3.5 text-sm font-semibold flex items-center gap-2 w-full sm:w-auto justify-center"><Compass size={17} /> Contact Us</Link>
        </div>
        <a href={SITE.phoneHref} className="mt-6 inline-flex items-center gap-2 text-brand font-semibold hover:opacity-80 transition-opacity">
          <Phone size={16} /> Or call {SITE.phone}
        </a>
      </div>
    </SubLayout>
  );
}
